import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, getUserInfo, userExists, registerNewUser, getSubscriptionStatus } from '../firebase/config';
import { fecha } from '../utils/utils';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

// Hook personalizado para usar el contexto
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);         // Info del usuario
  const [premium, setPremium] = useState(false);  // Estado de suscripción o VIP
  const [loading, setLoading] = useState(true);   // Esperando respuesta de Firebase
  const [registered, setRegistered] = useState(true); // Usuario ha completado proceso
  const [planName, setPlanName] = useState(null); // Nombre del plan

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        const isRegistered = await userExists(firebaseUser.uid);

        if (isRegistered) {
          const userInfo = await getUserInfo(firebaseUser.uid);
          setUser(userInfo);

          if (userInfo.processCompleted) {
            const subs = await getSubscriptionStatus(firebaseUser.uid);

            // --- 👇 NUEVA LÓGICA VIP 👇 ---
            if (userInfo.vip === true) {
              // Usuario marcado como VIP → acceso como plan "Explora +"
              setPremium(true);
              setPlanName("Plan Explora+");
            } else {
              // Usuario normal → depende de su suscripción
              setPremium(subs.active);
              setPlanName(subs.active && subs.planName ? subs.planName : "gratis");
            }
            // --- 👆 FIN LÓGICA VIP 👆 ---

            setRegistered(true);
          } else {
            setRegistered(false);
            navigate('/elige-usuario'); // Llevar a completar info, no login
          }
        } else {
          // Registro inicial del usuario en base de datos
          await registerNewUser({
            uid: firebaseUser.uid,
            email: firebaseUser.email,
            displayName: firebaseUser.displayName,
            registerDate: new Date(),
            username: '',
            likes: [],
            processCompleted: false,
            sendAlerts: true,
            vip: false // 👈 Nuevo campo por defecto
          });

          // Crear objeto usuario con estructura esperada
          const newUserInfo = {
            uid: firebaseUser.uid,
            email: firebaseUser.email,
            displayName: firebaseUser.displayName,
            registerDate: new Date(),
            username: '',
            likes: [],
            processCompleted: false,
            sendAlerts: true,
            vip: false // 👈 Nuevo campo por defecto
          };

          setUser(newUserInfo);
          setRegistered(false);
          navigate('/elige-usuario'); // Llevar a completar info
        }
      } else {
        setUser(null);
        setPremium(false);
        setRegistered(false);
        //navigate('/login');
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  return (
    <AuthContext.Provider value={{ user, premium, loading, registered, planName }}>
      {children}
    </AuthContext.Provider>
  );
};
